<!-- https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B%E7%AE%A1%E7%90%86 -->
<!-- 放款申請管理 -->
<template>
	<div v-if="$route.meta.listKeepAlive">
		<workbench
			api="coopLoanIouModify"
			:columns="columns"
			:toolbar="toolbar"
			@editData="editData"
			@addData="editData"
		></workbench>

		<el-dialog :visible.sync="isChooseIou" append-to-body :show-close="false" class="modal-show">
			<workbench
				api="coopLoanIou"
				:columns="columnsIou"
				:toolbar="toolbarIou"
				:query="query"
				@editData="chooseIou"
			></workbench>
		</el-dialog>
	</div>
	<router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";

export default {
	name: "loan_plan_change",
	components: { Workbench },
	data() {
		return {
			toolbar: { removeable: false },
			toolbarIou: { addable: false, removeable: false, select: false, pageQuery: false },
			isChooseIou: false,
			query: {
				action: "getRunningIou",
			},
			columns: [
				{
					prop: "code",
					label: "專案編號",
				},
				{
					prop: "iouNumber",
					label: "借據號碼",
				},
				{
					prop: "memberAccount",
					label: "社員帳號",
				},
				{
					prop: "memberName",
					label: "社員名稱",
				},
				{
					prop: "iouModifyStatus",
					label: "狀態",
					renderFunction(h, scope, enumData) {
						return h(
							"div",
							scope.row.iouModifyStatus
								? enumData.coopLoanIouModifyStatus[
										scope.row.iouModifyStatus
								  ]
								: ""
						);
					},
				},
				{
					prop: "oldProjectName",
					label: "原方案",
				},
				{
					prop: "newProjectName",
					label: "新方案",
				},
				{
					prop: "calculateBaseDate",
					label: "結算日期",
				},
				{
					prop: "loanPriceBeforePay",
					label: "結算時本金結餘",
					addcomma: true,
					renderFunction(h, scope, enumData) {
						let calculateInfo = scope.row.calculateInfo
							? JSON.parse(atob(scope.row.calculateInfo))
							: null;

						let result =
							calculateInfo == null
								? ""
								: calculateInfo.loanPriceBeforePay;
						return h("div", this.$addcomma(result));
					},
				},
				{
					prop: "payBackInterest",
					label: "結算時欠繳利息",
					addcomma: true,
					renderFunction(h, scope, enumData) {
						let calculateInfo = scope.row.calculateInfo
							? JSON.parse(atob(scope.row.calculateInfo))
							: null;

						let result =
							calculateInfo == null
								? ""
								: calculateInfo.payBackInterest;
						return h("div", this.$addcomma(result));
					},
				},
				{
					prop: "payBackBreakPrice",
					label: "結算時欠繳違約金",
					addcomma: true,
					renderFunction(h, scope, enumData) {
						let calculateInfo = scope.row.calculateInfo
							? JSON.parse(atob(scope.row.calculateInfo))
							: null;

						let result =
							calculateInfo == null
								? ""
								: calculateInfo.payBackBreakPrice;
						return h("div", this.$addcomma(result));
					},
				},
				{
					prop: "interestAmountReduction",
					label: "利息減免金額",
					addcomma: true,
				},
				{
					prop: "annualAmountReduction",
					label: "違約金減免金額",
					addcomma: true,
				},
				{
					prop: "rcdName",
					label: "理事會紀錄"
				},
				{
					prop: "updateTime",
					label: "最後修改",
				},
				{
					prop: "updateUserName",
					label: "最後修改人員",
				},
			],
			columnsIou: [
				{
					prop: "iouNumber",
					label: "借據號碼",
				},
				{
					prop: "",
					label: "社員帳號",
					renderFunction(h, scope) {
						return h(
							"div",
							`${
								scope.row.memberAccount
									? scope.row.memberAccount
									: ""
							} ${
								scope.row.memberName ? scope.row.memberName : ""
							}`
						);
					},
				},
				{
					prop: "memberName",
					label: "社員名稱",
				},
				{
					prop: "iouDateStart",
					label: "借款期間(起)",
					renderFunction(h, scope) {
						return h(
							"div",
							scope.row.iouDateStart
								? scope.row.iouDateStart.split(" ")[0]
								: ""
						);
					},
				},
				{
					prop: "iouDateEnd",
					label: "借款期間(迄)",
					renderFunction(h, scope) {
						return h(
							"div",
							scope.row.iouDateEnd
								? scope.row.iouDateEnd.split(" ")[0]
								: ""
						);
					},
				},
			],
		};
	},
	methods: {
		chooseIou(data, row) {
			let url = API.coopLoanIouModify + "?action=append";

			let dataPost = new FormData();
			dataPost.append("iouNumber", row.iouNumber);
			dataPost.append("memberId", row.memberId);
			const postCB = (json) => {
				this.showAjaxSuccessMsg();
				this.isChooseIou = false;
				this.$router.push({
					name: "loan_plan_change_edit",
					params: { id: json.resultData.id },
				});
			};
			this.mAxiosPost(url, dataPost, postCB);
		},
		editData(id) {
			if (id == "new") {
				this.isChooseIou = true;
				return;
			}

			this.$router.push({
				name: "loan_plan_change_edit",
				params: { id: id },
			});
		},
	},
};
</script>